'use strict';

const jQuery = require('jquery');

const DndZone = require('./../service/dndZone');
const SaveManager = require('./../component/SaveManager');
const EditIframe = require('./../service/editIframe');

const BTN_HEIGHT_SIZE = 23;
const MIN_HEIGHT = 40;

let startMousePosition;

let currentHeight;
let startHeight;

let $heightInfo = jQuery('<div class="cloud-image-height-info"></div>');
let $guideline = jQuery('<div class="cloud-guideline"></div>');

const calculButtonPosition = ($btnResize, content) => {
    let contentHeight = content.$.outerHeight();
    let contentWidth = content.$.outerWidth();

    $btnResize.css('top', (contentHeight - BTN_HEIGHT_SIZE) + 'px');
    $btnResize.css('left', (contentWidth / 2) + 'px');
};

const getResizeBtn = (content) => {
    return content.$.find('.cloud-edit-content').find('.cloud-resize');
};

const onMove = function(event) {
    let content = event.data.content;
    let $resizeBtn = getResizeBtn(content);
    let $resizeElement = content.$.find('.resize-element:first');

    $resizeElement = $resizeElement.length ? $resizeElement : content.$;

    currentHeight = startHeight + (event.clientY - startMousePosition);
    $resizeElement.css('height', currentHeight > MIN_HEIGHT ? currentHeight : MIN_HEIGHT + 'px');

    $heightInfo.text(content.$.outerHeight());
    $heightInfo.css('top', (content.$.outerHeight() - $heightInfo.outerHeight()) + 'px');

    $guideline.css('top', content.$.outerHeight() + 'px');

    calculButtonPosition($resizeBtn, content);
};

const stopResize = function(event) {
    let content = event.data.content;
    let $resizeBtn = getResizeBtn(content);

    DndZone.apply();

    content.$.removeClass('cloud-resizing');
    content.$.find('.cloud-image-height-info').remove();
    content.$.find('.cloud-guideline').remove();

    content.addParameter('height', currentHeight);

    $resizeBtn.html('<i class="icon icon-margin"></i>');

    SaveManager.save();

    EditIframe.unApply(content);

    jQuery('body').off('mousemove.resize');
    jQuery('body').find('.main').removeAttr('style');
};

const startResize = function(content) {
    let data = {
        'content': content,
    };
    let $content = content.$;

    if (content.getProperties('is_image')) {
        return;
    }

    EditIframe.apply(content);

    $heightInfo.text($content.outerHeight());
    $content.append($heightInfo);
    $heightInfo.css('top', ($content.outerHeight() - $heightInfo.outerHeight()) + 'px');
    $heightInfo.css('left', ($content.outerWidth() / 2) + 'px');

    $content.append($guideline);
    $guideline.css('top', $content.outerHeight() + 'px');
    $guideline.css('left', '-' + $content.offset().left + 'px');

    startHeight = content.$.height();

    startMousePosition = content.event.clientY;

    DndZone.destroy();

    content.$.addClass('cloud-resizing');

    jQuery('body').on('mousemove.resize', data, onMove);
    jQuery('body').one('mouseup.resize', data, stopResize);
    jQuery('body').find('.main').attr('style', 'overflow:  hidden');

    calculButtonPosition(getResizeBtn(content), content);
};

module.exports.onMousedown = startResize;
module.exports.calculButtonPosition = calculButtonPosition;
